module.exports = __webpack_public_path__ + "img/carshina21_08.08b102aa.jpg";